function clampChannel(value) {
  return Math.max(0, Math.min(255, Number(value) || 0));
}

function parseHexColor(input) {
  const value = String(input || '').trim();
  const match = value.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (!match) return null;
  const hex = match[1];
  if (hex.length === 3) {
    return {
      r: parseInt(hex[0] + hex[0], 16),
      g: parseInt(hex[1] + hex[1], 16),
      b: parseInt(hex[2] + hex[2], 16),
    };
  }
  return {
    r: parseInt(hex.slice(0, 2), 16),
    g: parseInt(hex.slice(2, 4), 16),
    b: parseInt(hex.slice(4, 6), 16),
  };
}

function parseRgbColor(input) {
  const value = String(input || '').trim();
  const match = value.match(/^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)(?:\s*,\s*[\d.]+\s*)?\)$/i);
  if (!match) return null;
  return {
    r: clampChannel(match[1]),
    g: clampChannel(match[2]),
    b: clampChannel(match[3]),
  };
}

function parseColor(input) {
  return parseHexColor(input) || parseRgbColor(input);
}

function toLinear(value) {
  const normalized = value / 255;
  return normalized <= 0.03928
    ? normalized / 12.92
    : ((normalized + 0.055) / 1.055) ** 2.4;
}

function relativeLuminance(color) {
  return (
    0.2126 * toLinear(color.r) +
    0.7152 * toLinear(color.g) +
    0.0722 * toLinear(color.b)
  );
}

function contrastRatio(a, b) {
  const lighter = Math.max(relativeLuminance(a), relativeLuminance(b));
  const darker = Math.min(relativeLuminance(a), relativeLuminance(b));
  return (lighter + 0.05) / (darker + 0.05);
}

export function resolveSidebarTextColor(theme = {}, fallback = '#111111') {
  const explicit = String(theme?.sidebar_text_color || '').trim();
  if (explicit) return explicit;

  const background = parseColor(theme?.card_background);
  if (!background) return String(theme?.text_color || fallback || '#111111');

  const white = { r: 255, g: 255, b: 255 };
  const black = { r: 17, g: 17, b: 17 };
  return contrastRatio(background, white) >= contrastRatio(background, black)
    ? '#ffffff'
    : '#111111';
}
